import { Injectable } from '@angular/core';
import { AngularFireAuth } from "@angular/fire/auth";
import { AngularFireDatabase } from "@angular/fire/database";
import { LogService } from "../servicios/log-servicios";

//import { auth } from 'firebase/app';
import { Observable } from 'rxjs';		//, ReplaySubject 
import { map } from 'rxjs/operators';		//, tap, catchError, first
import { SuperUser, User, UserAut, UserEmp, UsrPwd } from '../interfaces/user-interfaces';
import { DataEmpresaService } from '../servicios/data-empresa-servicios';

@Injectable({
  providedIn: 'root'
})
export class FireUserService {
  constructor(
    private afAuth: AngularFireAuth,
    private db: AngularFireDatabase,
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) { }


  async afLogin(email: string, password: string): Promise<firebase.auth.UserCredential> {
    //this.logService.consoleLog('2','CS FU ' + email);
    //En otra versión hay un auth después de afAuth
    //return this.afAuth.auth.signInWithEmailAndPassword(email, password);
    await this.afAuth.setPersistence('none');
    return this.afAuth.signInWithEmailAndPassword(email, password);
    //No pongo then ni catch aquí para que dé los mensajes en el componente que llama
  }

  afRegistrar(email: string, password: string): Promise<firebase.auth.UserCredential> {
    return this.afAuth.createUserWithEmailAndPassword(email, password);
  }

  afResetearPwd(email: string): Promise<void> {
    return this.afAuth.sendPasswordResetEmail(email);
  }

  afLogout(): Promise<void> {
    return this.afAuth.signOut();
  }

  /*
  verifyMail$(): Promise<void> {
    var usr1 = auth().currentUser;
    return usr1.sendEmailVerification();
  }
  */
  //Aquí no había async en la función ni await en el return, ni el paréntesis en el await, el return era así:
  //return this.afAuth.currentUser.sendEmailVerification() 
  //pero daba este error:
  //Property 'sendEmailVerification' does not exist on type 'Promise<User>'.ts(2339) Did you forget to use 'await'?
  //Tanto en el VSCode como en esta pregunta:
  //https://stackoverflow.com/questions/62492078/send-email-verification-with-firebase-using-angularfire-v6
  //recomiendan usar async y await y ahora que ya hay un User ya hay sendEmailVerification
  async verifyMail$(): Promise<void> {
    return (await this.afAuth.currentUser).sendEmailVerification();
  }
  //---------------------------------------------------------------------------------------------
  //---------------------------------------------------------------------------------------------

  //esta rutina solo es para probar que funciona la conexión a la base
  updateFireIngreso$(seqUsr: string, modeloUsr: UsrPwd): Promise<void> {
    //this.logService.consoleLog('2',"CS FU fus uFU seqUsr: " + seqUsr + "; modeloUsr: " + JSON.stringify(modeloUsr));
    //update solo cambia los campos enviados  
    return this.db
      .list('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/ingresos/')
      .update(seqUsr, modeloUsr);
  }

  getFireSuperUser$(uid: string): Observable<boolean> {
    return this.db.object<SuperUser>('super/easymed/' + uid)
      .valueChanges()
      .pipe(
        map(fs => {
          if (fs != undefined) {
            this.logService.consoleLog('2', 'CS FU super ' + fs.super ? 'true' : 'false');
            return fs.super;
          } else {
            return false;
          }
        })
      );
  }

  u1: User = new User;
  ua1: UserAut = new UserAut;
  ue1: UserEmp = new UserEmp;
  count: number = 0;

  getFireUserAut$(uid: string): Observable<UserAut> {
    return this.db.object<UserAut>('userAut/easymed/' + uid)
      .valueChanges()
      .pipe(
        map(fua => {
          if (fua != undefined) {
            this.logService.consoleLog('2', 'CS FU fua service get 2, ' + fua.uid + ', ' + fua.email);
          }
          this.ua1 = fua;
          return this.ua1;
        })
      );
  }

  getFireUserEmp$(uid: string): Observable<UserEmp> {
    return this.db.object<UserEmp>('userEmp/easymed/' + uid)
      .valueChanges()
      .pipe(
        map(fue => {
          if (fue != undefined) {
            this.logService.consoleLog('2', 'CS FU getFireUserEmp fue service get 2: ' + fue.email);
          }
          this.ue1 = fue;
          return this.ue1;
        })
      );
  }

  getFireUser$(uid: string): Observable<User> {
    return this.db.object<User>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/usuarios/datos/' + uid)
      .valueChanges()
      .pipe(
        map(fu => {
          this.logService.consoleLog('2', 'CS FU fu service get 5, long: ' + fu.email);
          this.u1 = fu;
          return this.u1;
        })
      );
  }

  //Muestra todos los usuarios en la consulta de Usuarios
  getFireUsersAdmin$(): Observable<User[]> {
    return this.db.list<User>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/usuarios/datos', ref =>
      //ref.orderByChild('email').equalTo(mail)	//
      ref.orderByChild('nombre')	//
    )
      .valueChanges()
      .pipe(
        map(fussa => {
          if (fussa.length === 0) {
            this.logService.consoleLog('2', 'CS FU fussa vacío');
          } else {
            this.logService.consoleLog('2', 'CS FU fussa service get 5, long: ' + fussa.length);
          }
          return fussa;
        })
      );
  }

  //Muestra solo el usuario propio en la consulta de Usuarios, parám es el uid del usr. 
  //Parecida a getFireUser$ pero devuelve un array, y parecida a getFireUsersAdmin$, pero devuelve un solo elemento
  getFireUsersUsuario$(uid: string): Observable<User[]> {
    return this.db.object<User>('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/usuarios/datos/' + uid)
      .valueChanges()
      .pipe(
        map(fusu => {
          this.logService.consoleLog('2', 'CS FU fusu service, ' + fusu.email);
          const fussu: User[] = [];
          fussu.push(fusu);
          return fussu;
        })
      );
  }

  //update puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  createFireUser$(objUser: User): Promise<void> {
    this.logService.consoleLog('2', 'CS FU cFU');
    this.logService.consoleLog('2', 'CS FU ' + objUser.nombre);
    return this.db
      .list('easymed/' + this.dataEmpresaService.empAut.prefijoBase + '/usuarios/datos/')
      .update(objUser.uid, objUser);
  }


  //Muestra todos los userAuts en la pantalla de Activación
  getFireUserAutsAdmin$(): Observable<UserAut[]> {
    return this.db.list<UserAut>('userAut/easymed', ref =>
      ref.orderByChild('fechaHora')	//
    )
      .valueChanges()
      .pipe(
        map(fuasa => {
          if (fuasa.length === 0) {
            this.logService.consoleLog('2', 'CS FUAs fuasa vacío');
          } else {
            this.logService.consoleLog('2', 'CS FUAs fuasa service get 5, long: ' + fuasa.length);
          }
          return fuasa;
        })
      );
  }

  //set puede usarse para crear o actualizar. Requiere que ya tenga un uid. 
  createFireUserAut$(objUserAut: UserAut): Promise<void> {
    //const objUserAut = {autorizado: autorizado, email:mail}
    this.logService.consoleLog('2', 'CS FU cFUA');
    this.logService.consoleLog('2', 'CS FU ' + objUserAut.nombre);
    return this.db.list('userAut/easymed/').set(objUserAut.uid, objUserAut);
  }

  //actualiza un UserAut, es rutina igual a create
  updateFireUserAut$(objUserAut: UserAut): Promise<void> {
    this.logService.consoleLog('2', 'CS FireUsr updateUA ' + objUserAut.nombre);
    return this.db.list('userAut/easymed/').set(objUserAut.uid, objUserAut);
  }

}
